<template>
  <div class="loadingContent" v-if="loadingShow" :style="{backgroundColor: loadingBackgroundColor }">
    <div class="loadingBox">
      <img class="loadingImg" :src="loadingImg" alt="" />
      <div class="loadingText" v-show="loadingText">{{loadingText}}</div>
    </div>
  </div>
</template>

<script>
const loadingImg = require('./loading-gif-white.gif')

export default {
  name: 'loadingGif',
  data () {
    return {
      loadingImg
    }
  },
  props: {
    loadingShow: {
      type: Boolean,
      default: false
    },
    loadingText: String,
    loadingBackgroundColor: String
  }
}
</script>

<style>
.loadingContent {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loadingContent .loadingBox {
  width: 150px;
  height: 240px;
  text-align: center;
}
.loadingContent .loadingBox .loadingImg {
  width: 60px;
  height: 60px;
}
.loadingContent .loadingBox .loadingText {
  font-size: 14px;
  font-family: Roboto, PingFang SC, Segoe UI, "Microsoft YaHei", "微软雅黑", Tahoma, Geneva, sans-serif !important;
  font-weight: 400;
  color: rgba(31, 31, 31, 0.55);
  line-height: 22px;
  margin-top: 15px;
}
</style>
